import React, { FC, useMemo } from 'react'
import { Image } from '@chakra-ui/react'
import { LogosBrandMap, hostNameMap } from '../../state/interfaces'

export interface LogoBrandProps {
  domain: string
}

export const LogoBrand: FC<LogoBrandProps> = ({ domain }) => {
  const logoLabel = useMemo(() => LogosBrandMap[domain], [domain])
  const renderedLogoSrc = useMemo(() => hostNameMap[domain], [domain])

  return <Image src={renderedLogoSrc} alt={logoLabel} objectFit="cover" width="35vw" maxWidth="132px" />
}
